// [ai] The one JSON transport the write clients share (entry, inbox, cites, imports): a typed error carrying the status and the
// server's body, so a caller can read `expected` from a 409 or the message from a 400 without touching fetch itself.
export class HttpError extends Error {
  override readonly name = "HttpError";
  constructor(readonly status: number, message: string, readonly body: Record<string, unknown> = {}) { super(message); }
}
export type Fetch = typeof fetch;
export const realFetch: Fetch = (...a) => fetch(...a);

/** fetch + JSON; a non-2xx answer throws HttpError(status, the server's `error` or the status, the body). */
export async function jsonFetch<T = Record<string, unknown>>(url: string, init: RequestInit = {}, fetchFn: Fetch = realFetch): Promise<T> {
  const r = await fetchFn(url, init);
  let j: Record<string, unknown> = {}; try { j = (await r.json()) as Record<string, unknown>; } catch { j = {}; }
  if (!r.ok) throw new HttpError(r.status, typeof j.error === "string" ? j.error : `${r.status} ${url}`, j);
  return j as T;
}
export const JSON_HEADERS = { "Content-Type": "application/json" };
export const postJson = <T = Record<string, unknown>>(url: string, body: unknown, fetchFn: Fetch = realFetch, extra: RequestInit = {}) =>
  jsonFetch<T>(url, { method: "POST", headers: JSON_HEADERS, body: JSON.stringify(body), ...extra }, fetchFn);
